import React, {useEffect, useState} from 'react';
import {Translate} from "../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import Select from "react-select";
import CustomFloatingLabelSelect from "../../floating-custom-select/CustomFloatingLabelSelect";

const SelectYesOrNo = ({onChange, defaultValue, id, placeholder, ...props}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const [value, setValue] = useState(null);

    const optionsYesOrNO = [
        {value: true, label: t(lang, "edi.common.select_yes_or_no.option.yes")},
        {value: false, label: t(lang, "edi.common.select_yes_or_no.option.no")},
        {value: null, label: t(lang, "edi.common.select_yes_or_no.option.skip")}
    ]

    useEffect(() => {
        if (defaultValue !== null) {
            const val = optionsYesOrNO.find(v => v.value === defaultValue);
            setValue(val);
        } else {
            setValue(optionsYesOrNO[2]);
        }
    }, [defaultValue])

    const onChangeState = option => {
        setValue(option);
        onChange(option);
    }

    const getOptionValue = option => option.value;
    const getOptionLabel = option => t(lang, option.label);

    return (
            <CustomFloatingLabelSelect
                value={value}
                hideSelectedOptions
                onChange={onChangeState}
                options={optionsYesOrNO}
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                label={placeholder}
                {...props}
            />
    );
};

export default SelectYesOrNo;
